var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { forwardRef } from 'react';
import { fieldBaseStyle } from '../theme';
export var SimpleTextField = forwardRef(function (_a, ref) {
    var _b = _a.type, type = _b === void 0 ? 'text' : _b, onChange = _a.onChange, error = _a.error, props = __rest(_a, ["type", "onChange", "error"]);
    return (jsx("input", __assign({ ref: ref, type: type, onChange: function (e) {
            var value = e.target.value;
            onChange(value);
        }, sx: __assign(__assign({}, fieldBaseStyle), { appearance: 'none', fontSize: 2, color: 'text', outline: 'none', borderColor: error ? 'danger' : 'grey' }) }, props)));
});
SimpleTextField.displayName = 'SimpleTextField';
//# sourceMappingURL=SimpleTextField.js.map